import { Injectable } from '@angular/core';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';

import { Observable } from 'rxjs/Observable';
import { HttpClient} from '@angular/common/http'; 

@Injectable()
export class ReportsService {

  constructor(private http: HttpClient) { }
  
  getAccountDetails(projectId) {
	return this.http.get(environment.appUrl + "account/accountDetails",{params:{projectId:projectId}})
	  .map(result => {		
		return result;
	});
  }
  
  getFieldWiseReports(projectId, selFldVal, selFldValArr='') {
	return this.http.get(environment.appUrl + "account/project/reports",{params:{projectId:projectId,selFldVal:selFldVal, selFldValArr:selFldValArr}})
	  .map(result => {		
		return result;
	});
  }
  
  downloadCSV(projectId,selectedField,type,section,fldValue, selectedFieldM, fldValueM) {
	return this.http.get(environment.appUrl + "account/project/reports/download",{params:{projectId:projectId,selectedField:selectedField,type:type,section:section,fldValue:fldValue,selectedFieldM:selectedFieldM,fldValueM:fldValueM}})
	  .map(result => {		
		return result;
	});
  }

  saveReportSetting(formValue, projectId) {
	return this.http.post(environment.appUrl + "account/project/reports/saveReportSetting",{formData : formValue, projectId})
	.map(result => {		
		return result;
	});
  }

  getReportSetting(projectId, listType='') {
	return this.http.get(environment.appUrl + "account/project/reports/getReportSetting",{params: { projectId, listType:listType }})
	.map(result => {		
		return result;
	}); 
  }

  updateReportSetting(reportId, updateFld, updateValue, projectId) {
	return this.http.put(environment.appUrl + "account/project/reports/updateReportSetting",{ reportId, updateFld, updateValue, projectId })
	.map(result => {		
		return result;
	}); 
  }

  getFieldOptions(projectId, tblName) {
	return this.http.get(environment.appUrl + "account/project/reports/getFieldOptions",{params: { projectId, tblName }})
	.map(result => {		
		return result;
	}); 
  }

  datadownloadStore(projectId, formData, dataId) {
	return this.http.post(environment.appUrl + "account/project/reports/datadownloadStore",{ projectId, formData, dataId })
	.map(result => {		
		return result;
	}); 
  }

  getDatadownloadField(projectId) {
	return this.http.get(environment.appUrl + "account/project/reports/getDatadownloadField",{ params :{ projectId }})
	.map(result => {		
		return result;
	}); 
  }

}
